/* Pages */
export * from './home/home.component';
export * from './product/product.component';
export * from './partner/partner.component';
export * from './support/support.component';
export * from './contact-us/contact-us.component';
export * from './error-page/error-page.component';
export * from './about-us/careers/careers.component';
export * from './privacy-policy/privacy-policy.component';
export * from './terms-of-us/terms-of-us.component';
export * from './epps-smart-erp/epps-smart-erp.component';
export * from './indra/indra.component';
export * from './app.component';

/* Components */
export * from './components/contact-form/contact-form.component';
export * from './components/demo-contact-form/demo-contact-form.component';
export * from './components/header/header.component';
export * from './components/footer/footer.component';
export * from './components/apply-job-form/apply-job-form.component';
